import { render, staticRenderFns } from "./BalanceReports.vue?vue&type=template&id=8a8b1cb4&"
import script from "./BalanceReports.vue?vue&type=script&lang=js&"
export * from "./BalanceReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a8b1cb4')) {
      api.createRecord('8a8b1cb4', component.options)
    } else {
      api.reload('8a8b1cb4', component.options)
    }
    module.hot.accept("./BalanceReports.vue?vue&type=template&id=8a8b1cb4&", function () {
      api.rerender('8a8b1cb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/reports/BalanceReports.vue"
export default component.exports